import Entity from 'utilities/entity';

class Assessment extends Entity {}

export default new Assessment();
